import { lazy } from "react";

const EmpOfferLetter = lazy(() => import("../Component/Recommendation/EmpOfferLetter"));
const AddOfferLetter = lazy(() => import("../Component/OfferLetter/AddOfferLetter"));
const EditOfferLetter = lazy(() => import("../Component/OfferLetter/EditOfferLetter"));
const OfferLetterList = lazy(() => import("../Component/OfferLetter/OfferLetterList"));
const EditEmpOfferLetter = lazy(() => import("../Component/Recommendation/EditEmpOfferLetter"));
const RO_OL = lazy(() => import("../Component/Role_OL/RO_OL"));
const BMOL = lazy(() => import("../Component/Role_OL/BMOL"));
const AicOL = lazy(() => import("../Component/Role_OL/AicOL"));
const CHOL = lazy(() => import("../Component/Role_OL/CHOL"));
const RO_BMcontractual = lazy(() => import("../Component/Role_OL/RO_BMcontractual"));
const CCHoffer = lazy(() => import("../Component/Role_OL/CCHoffer"));
const CRH = lazy(() => import("../Component/Role_OL/CRH"));
const CBM = lazy(() => import("../Component/Role_OL/CBM"));
const IAH = lazy(() => import("../Component/Role_OL/IAH"));
const IBM = lazy(() => import("../Component/Role_OL/IBM."));
const ThankYou = lazy(() => import("../Component/OfferLetter/ThankYou"));
const Waiting = lazy(() => import("../Component/OfferLetter/Waiting"));
const OnboardingSuccess = lazy(() => import("../Component/OfferLetter/OnboardingSuccess"));

const offerLetterRoutes = [
  { path: "/employee-offer-letter-list", element: <EmpOfferLetter />, protected: true },
  { path: "/add-offer-letter", element: <AddOfferLetter />, protected: true },
  { path: "/edit-offer-letter/:id", element: <EditOfferLetter />, protected: true },
  { path: "/manage-offer-letter", element: <OfferLetterList />, protected: true },
  { path: "/edit-employee-offer-letter/:id", element: <EditEmpOfferLetter />, protected: true },
  { path: "/preview-offer-letter/ro", element: <RO_OL />, protected: true },
  { path: "/preview-offer-letter/bm", element: <BMOL />, protected: true },
  { path: "/preview-offer-letter/aic", element: <AicOL />, protected: true },
  { path: "/preview-offer-letter/ch", element: <CHOL />, protected: true },
  {
    path: "/preview-offer-letter/contractual-ro/bm",
    element: <RO_BMcontractual />,
    protected: true,
  },
  { path: "/preview-offer-letter/cch", element: <CCHoffer />, protected: true },
  { path: "/preview-offer-letter/crh", element: <CRH />, protected: true },
  { path: "/preview-offer-letter/cbm", element: <CBM />, protected: true },
  { path: "/preview-offer-letter/iah", element: <IAH />, protected: true },
  { path: "/preview-offer-letter/ibm", element: <IBM />, protected: true },
  { path: "/thank-you", element: <ThankYou />, protected: false },
  { path: "/waiting", element: <Waiting />, protected: false },
  { path: "/onboarding-success", element: <OnboardingSuccess />, protected: false },
];

export default offerLetterRoutes;
